import React, {lazy} from 'react'

export default function LogRocket(props) {
  const {integrations: config} = props

  if (!config?.integrations?.logRocketId) return null

  const LogRocketIntegration = lazy(() => import('./LogRocketIntegration'))

  return <LogRocketIntegration {...props} />
}
